import axios from 'axios';
import {useState , useEffect} from 'react'
import MyCard from './MyCard';
import "./display.css";
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import SearchIcon from '@mui/icons-material/Search';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const DisplayPosts = () => {

    const[post , setPost] = useState([]);
    const [searchParams] = useSearchParams();
    const [search , setSearch] = useState("");
    let category = searchParams.get("category");
    const url = "https://my-blog-wzcd.onrender.com";
    const [result,setResult] = useState("Loading...");
    const [searchResult , setSearchResult] = useState([]);
    const [scrollBtn , setScrollBtn] = useState(false);


    async function getPost(){
      try {
        let arrayOfPost;
      if(category && category !== "all"){
        arrayOfPost = await axios.get(`${url}/api/post`);
        const filtered = arrayOfPost.data?.post.filter((post)=> post.category === category);
        if(!filtered.length){
          setResult("No Post Available");
        }
        setSearchResult(filtered)
       return setPost(filtered);
      }
        arrayOfPost = await axios.get(`${url}/api/post`);
        setPost(arrayOfPost.data.post);
        setSearchResult(arrayOfPost.data.post);
        if(!arrayOfPost.data.post.length){
          setResult("No Post Available");
        }
      } catch (error) {
        error.response ?
        toast.error(error.response.data.message.toUpperCase()) :
        toast.error(error.message)
      }
    }

    function searchPost(){
      // search by author-name/title
      setResult("Loading...");
     const finalResult = post.filter(singlePost => {
         if(singlePost.author.toLowerCase().includes(search.toLowerCase())){
          singlePost.isValid = true;
          return singlePost
        } else if(singlePost.title.toLowerCase().includes(search.toLowerCase())){
          singlePost.isValid = true;
        return singlePost
      }
    })
    if(finalResult.length === 0){
      setResult("NO MATCH FOUND");
    }
    setSearchResult(finalResult)
    }

    function scrollToTop(){
      window.scrollTo({top:0,behavior:"smooth"})
    }


    useEffect(()=>{
        getPost()
    },[category])

    useEffect(()=>{
      if(search.length === 0) setSearchResult(post);
    },[search])

    useEffect(() => {
      const handleScroll = () => {
        setScrollBtn(window.scrollY > 200); 
      };
  
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);

  return (
    <>
    <div id="search-container" style={{margin:"5px"}}>
      <span> <SearchIcon style={{color:"white"}} /> </span>  
      <input id="search-field" placeholder='looking for...' value={search} onChange={e => setSearch(e.target.value)} />
      <button id="search-button" onClick={searchPost}>SEARCH</button>
      </div>

      <div className='display-container'>
        
       {
        searchResult.length ? 
          [...searchResult].reverse().map((singlePost)=>{
              return <MyCard post={singlePost} key={singlePost._id} /> 
            })
        
        : <div style={{marginTop:"15px",display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}> <span style={{color:"white"}}>
          {result}
        </span> </div>
       }
    </div>

    { scrollBtn && 
      <div id="scroll-btn">
      <span onClick={scrollToTop}> <ArrowUpwardIcon style={{color:"#116466"}}/> </span>
      </div>
    }
    </>
      
  )
}

export default DisplayPosts